import TermsAndConditions from './TermsAndConditions/TermsAndConditions';
import MarketingConsents from './MarketingConsents/MarketingConsents';

const TermsAndConsents = () => (
  <div>
    <TermsAndConditions />
    <MarketingConsents />
  </div>
);

export default TermsAndConsents;
